module.exports = __webpack_public_path__ + "static/media/menu_preAdvise_hoverActive.85bf2175.svg";